import ButtonV2 from "components/individual/ButtonsV2/Button";
import React, { useContext } from "react";
import { ContextOdc } from "..";
import Status from "./Status";
import ui from "./styles.module.scss";
import Icon from "components/individual/HeaderIcon";
import CustomerSocialReason from "./SocialReason";
import Excel from "../Excel";
import Dates from "./Dates";
import Create from "./Create";
import SearchOc from "./SearchOc";
import UENV2 from "components/general/Forms/Selects/UENV2";

export default function Filter() {
  const { triggerSearch, setUen, uen } = useContext(ContextOdc);

  return (
    <div className={ui.filter}>
      <CustomerSocialReason />

      <Status />

      <SearchOc />

      <Dates />
      <div style={{ width: "200px" }}>
        <UENV2
          isClearable={true}
          onChange={(uen) => setUen(uen?.UENID||null)}
          value={uen}
        />
      </div>

      <ButtonV2 onClick={triggerSearch}>
        <span>Buscar</span>
        <Icon icon="search" />
      </ButtonV2>

      <Create />

      <Excel />
    </div>
  );
}
